import "./DashboardActivitiesTab.css";

import { VersionConflictModal } from "../../../../../templates/DeveloperProjectCardWithTabsTemplate/components";
import { ToggleTabs } from "../../../../../widget";
import { DashboardTabTable } from "../DashboardTabTable";
import { useDashboardActivitiesTab } from "./useDashboardActivitiesTab";

const DashboardActivitiesTab = (): JSX.Element => {
  const {
    columns,
    isLoading,
    setShowVersionConflictModal,
    showVersionConflictModal,
    newVersionActivityHistory,
    draftActivityHistoryUuid,
    onChange,
    activeTab,
    onTabChange,
    onViewMore,
    toggleTabsList,
  } = useDashboardActivitiesTab();

  return (
    <>
      <DashboardTabTable
        title="Activities"
        columns={columns}
        isLoading={isLoading}
        noDataMessage="No activities to display"
        onChange={onChange}
        gridKey={activeTab}
        onViewMore={onViewMore}
        actions={
          <div className="DashboardActivitiesTabToggle">
            <ToggleTabs
              toggleTabsList={toggleTabsList}
              currentTab={activeTab}
              onChange={onTabChange}
              size="small"
              variant="roundedSquare"
            />
          </div>
        }
      />
      <VersionConflictModal
        showVersionConflictModal={showVersionConflictModal}
        draftActivityHistoryUuid={draftActivityHistoryUuid}
        closeModal={() => setShowVersionConflictModal(false)}
        newVersionActivityHistory={newVersionActivityHistory}
      />
    </>
  );
};

export default DashboardActivitiesTab;
